define('viewmodels/app/__subrouter',['lodash', 'plugins/router', 'atn/atn'],
    function(_, router, atn) {
        'use strict';
        var basePath = '#app/',
            mapRoutes = [{
                route: 'analytics',
                title: 'Dashboard',
                moduleId: 'viewmodels/app/analytics/index',
                hash: basePath + 'analytics',
                nav: true,
                visible: true
            }, {
                route: ['reporting','reporting/:reportType'],
                title: 'Reports',
                moduleId: 'viewmodels/app/reporting/index',
                hash: basePath + 'reporting',
                nav: true,
                visible: true
            }, {
                route: ['schedule','schedule/:operation/:param'],
                title: 'Schedule Report',
                moduleId: 'viewmodels/app/components/__reportScheduleForm',
                hash: basePath + 'schedule',
                nav: false,
                visible: true
            }];
        var childRouter = router.createChildRouter()
            .makeRelative({
                moduleId: '',
                fromParent: true
            }).map(mapRoutes).buildNavigationModel();
        childRouter.__routeMap = mapRoutes;

        childRouter.guardRoute = guardRoute;
        return childRouter;

        function guardRoute(routeInfo, params) {
            var returnVal = true,
                //rid = session.session().rid,
                currentRoute = _.find(mapRoutes, {
                    moduleId: params.config.moduleId
                }),
                isAuth = currentRoute;
            if (atn.isLoggedOut()) {
                returnVal = '#site/logout';
            } else if (!isAuth) {
                //!ToDo
                returnVal = '#app/analytics/';
            }
            return returnVal;
        }
    });
